import type { FaireProductEntity } from "../../entity_types/product";

export const p_3d6mzczf2w: FaireProductEntity = {
  token: "p_3d6mzczf2w",
  type: "product",
  name: "Palo Santo Scented Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/72efba2f3bcb65a643091ebd01b3e5229a89f65faeb815b6d39cfdbfa06ada6c.jpeg",
  galleryImageUrls: [],
  priceDollars: 20,
  description:
    "Single note scented candle hand poured and crafted in Los Angeles exclusively by Putnam Design.\n\n• 9 oz of Soy wax\n• 40 hour burn time\n• Trim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:07.960Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
